import type { IconGlyph } from '../icon';

/**
 * Tractie `notification-thick` glyph (medium, 24×24), shown on the current nav item.
 *
 * Source: `@tractie/icons` v1.5.0, `dist/jsx/m/notification-thick.jsx`.
 * Verbatim copy of the SVG `d` attribute.
 */
export const iconNotificationThick: IconGlyph = {
  name: 'notification-thick',
  path: 'M20.89 16.93c-.19-.93-.71-1.79-1.56-2.59-.17-.19-.33-1.03-.33-1.74V9.68C19 6.73 17.9 5 15.34 4c-.42-1.16-1.56-2-2.84-2s-2.43.84-2.84 2C7.1 5 6 6.73 6 9.68v2.92c0 .7-.16 1.55-.31 1.71-.88.82-1.4 1.68-1.59 2.62-.05.25-.09.51-.11.87 0 1.23.98 2.19 2.24 2.19h3.44c.41 1.16 1.51 2 2.82 2s2.4-.84 2.82-2h3.44c1.26 0 2.24-.96 2.24-2.29a7 7 0 0 0-.1-.77M18.76 18H6.24c-.09 0-.24-.04-.24-.16.01-.17.03-.34.07-.5.11-.52.43-1.03 1.02-1.59.85-.85.91-2.62.91-3.15V9.68c0-2.28.71-3.28 2.81-3.98l.61-.2.07-.64c.05-.48.5-.86 1.01-.86s.95.39 1.01.86l.07.64.61.2c2.1.69 2.81 1.7 2.81 3.98v2.92c0 .52.07 2.3.93 3.17.57.53.89 1.04 1 1.57.03.16.06.33.07.47 0 .15-.15.19-.24.19',
};
